export default function GS_Format_Colors() {
  return (
    <div className="p-4">
      <h1>GS Format Colors</h1>
    </div>
  );
}
